import AdmanLogger from '@mail/adman-logger';

import xray from './xray';

const logger = new AdmanLogger({
    xray: xray,
});

export default logger;
